import type { ReduxApplicationState } from '../combinedReducer';

export const selectOfferLabelContent = (state: ReduxApplicationState) =>
  state.content.offerLabel || null;

export const selectPromoLabel = (state: ReduxApplicationState) => state.content.promoLabel || null;

export const selectTrustBannerContent = (state: ReduxApplicationState) =>
  state.content.trustBanner || null;
